import {Link} from "react-router-dom";

function BreadCrumb({breadCrumbItem}) {
    return (
        <nav className="mb-3" aria-label="breadcrumb">
            <ol className="breadcrumb">
                {
                    breadCrumbItem.map((item, index) => (
                        <li key={index} className={`breadcrumb-item ${item.isActive ? 'active' : ''}`} >
                            {
                              item.isActive ? item.text : <Link to={item.to} > {item.text} </Link>
                            }
                        </li>
                    ))
                }
            </ol>
        </nav>
    )
}
export default BreadCrumb;